import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { navigateTo } from "gatsby-link"
import { theme, Flex, Provider, Link } from "rebass"

import Header from "../components/Header"
import Footer from "../components/Footer"
import NavDropdown from "../components/NavDropdown"
import NavItem from "../components/NavItem"

import "normalize.css"
import "./index.css"
import "./foundation.css"
import "react-tippy/dist/tippy.css"
import "rc-slider/assets/index.css"

import logo from "../images/ykwc-logo-sm.png"
import colors from "../config/colors.js"

const navLinks = [
  {
    path: "/about/",
    title: "about",
  },
  {
    path: "/contact/",
    title: "contact",
  },
  {
    path: "/plans/",
    title: "plans",
  },
  {
    title: "back to main",
    href: "http://www.ykwc.com",
  },
]

class TemplateWrapper extends React.Component {
  constructor(props) {
    super(props)
    this.state = { scrolled: false, drawer: false }
    this.handleScroll = this.handleScroll.bind(this)
    this.toggleDrawer = this.toggleDrawer.bind(this)
  }

  toggleDrawer() {
    this.setState({ drawer: !this.state.drawer })
  }

  handleScroll() {
    this.setState({ scrolled: window.scrollY > 0 })
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll)
  }

  render() {
    const { children, location } = this.props

    return (
      <Provider
        theme={{
          colors: colors,
        }}
      >
        <Flex flex="1" flexDirection="column" style={{ minHeight: "100vh" }}>
          <Helmet
            title="Yellowknife Wireless"
            meta={[
              { name: "description", content: "Sample" },
              { name: "keywords", content: "sample, something" },
            ]}
          />
          <Header
            navLinks={navLinks}
            location={location}
            scrolled={this.state.scrolled}
            drawer={this.state.drawer}
            handleToggleDrawer={this.toggleDrawer}
          />
          <Flex flex="1" flexDirection="column">
            {children()}
          </Flex>
          <Footer />
        </Flex>
      </Provider>
    )
  }
}

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js